import React from 'react'
import { HaikuSVG  } from './assets/icons'
import NotificationManager from './notification-manager'
import Link from 'gatsby-link'
import { colors, colorsMapped, borderRadii, spacing, sizing } from './assets/shibui';
import SS from './assets/shared-styles';

const S = {
  navWrap: {
    width: '100%',
    zIndex: 3,
    position: 'relative',
    top: 0,
    left: 0,
  },
  linksHolster: {
    maxWidth: sizing.xxxl + 30,
    width: '100%',
    height: '100%',
    margin: '0 auto',
    padding: '13px 0 1px 10px',
  },
  link: {
    color: colors.ivory.color,
    paddingLeft: spacing.sm,
    paddingRight: spacing.sm,
    marginRight: spacing.sm,
    position: 'relative'
  },
  logoWrap: {
    height: 10,
    textTransform: 'uppercase',
    fontSize: 22
  },
  cta: {
    fontWeight: 700,
    marginTop: 2,
    border: '1px solid ' + colors.fuss50.color,
    borderRadius: borderRadii.button,
    padding: `${spacing.sm - 2}px ${spacing.lg - 2}px`,
    border: 'solid 1px ' + colorsMapped.borderColor.color,
  },
  linkSpecial: {
    fontWeight: 700,
    color: colors.tiger50.color,
    marginRight: spacing.xs,
    marginTop: 9
  },
  leftLinks: {
    display: 'inline-block',
    transform: 'translateY(-3px)'
  },
  active: {
    position: 'absolute',
    width: '100%',
    borderRadius: borderRadii.button,
    height: spacing.xs,
    backgroundColor: colors.fuss50.color,
    left: 0,
    bottom: '-6px'
  }
}

const Navbar = ({ location }) => {
  const onHome = location === "home" || (typeof window !== 'undefined') && window.location.pathname.substring(1) === "home"
  const onBlog = location === "blog" || (typeof window !== 'undefined') && window.location.pathname.substring(1) === "blog"
  const onAbout = location === "about" || (typeof window !== 'undefined') && window.location.pathname.substring(1) === "about"
  const onAnimator = location === "animator" || (typeof window !== 'undefined') && window.location.pathname.substring(1) === "animator"
  const lightMode = onHome || onAnimator

  return (
    <div style={S.navWrap} className="nav">
      <div style={S.linksHolster}>
        <Link tabIndex="1"
          style={{ ...S.logoWrap, ...S.link, ...!lightMode && { color: colors.midnight.color }}}
          to={{ pathname: "/"}}>
            <HaikuSVG size={30} color={lightMode ? colors.ivory.color : colors.midnight.color} vertOffset={6} />
            <div style={{ margin: "0 30px 0 8px", display: 'inline-block'}}>Haiku</div>
        </Link>

        <a tabIndex="6"
          className="nav-link right-float nav-link__button"
          style={{
            ...S.cta,
            ...onHome ? SS.ctaAlt : SS.ctaSecondaryText,
            ...onHome && {color: colors.tiger50.color}
          }}
          href="https://github.com/HaikuTeam/animator/">
          Download on Github
        </a>

        <div style={S.leftLinks}>
          <a tabIndex="5"
            className="stash"
            style={{...S.link, ...!lightMode && {color: colors.midnight.color}
            }}
            target="_blank"
            href="https://www.haikuforteams.com/#about">
            About
            <span style={{ ...onAbout && S.active }} />
          </a>
          <Link tabIndex="6"
            className="stash"
            style={{...S.link, ...!lightMode && {color: colors.midnight.color}
            }}
            to={{ pathname: "/blog/"}}>
            Blog
            <span style={{ ...onBlog && S.active }} />
          </Link>
        </div>
      </div>
      { onHome && <NotificationManager /> }
    </div>
  )
}

export default Navbar



// WEBPACK FOOTER //
// ./src/components/navbar.js